<template>
  <img class="w-10 mr-8" src="../../assets/images/footerLogo.svg" alt="Logo"/>
</template>

<script>
export default {
    name:'Logo'
}
</script>